import config from '../utils/config'
import request from '../utils/request'

const {api} = config
const {clientVersion, clientVersionOne} = api

/**
 * 查找
 */
export async function findIos(params) {
    return request({url: clientVersionOne, method: 'get', data: params,})
}

/**
 * 创建
 */
export async function createIos(params) {
    return request({url: clientVersion, method: 'post', data: params,})
}

/**
 * 更新
 */
export async function updateIos(params) {
    return request({url: clientVersionOne, method: 'patch', data: params,})
}

/**
 * 删除
 */
export async function deleteIos(params) {
    return request({url: clientVersionOne, method: 'delete', data: params,})
}


/**
 * 查找列表
 */
export async function findIoss(params) {
    return request({url: clientVersion, method: 'get', data: params,})
}




// WEBPACK FOOTER //
// ./src/services/ios.js